var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAv5NextStepsGraph = function SvgAv5NextStepsGraph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 11.25,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#fff",
    stroke: "#9B9AC8",
    strokeWidth: 1.5,
    "data-no-fill": "true"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.25,
    y: 11.25,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#fff",
    stroke: "#9B9AC8",
    strokeWidth: 1.5,
    "data-no-fill": "true"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 0.75,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#fff",
    stroke: "#9B9AC8",
    strokeWidth: 1.5,
    "data-no-fill": "true"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7v7M7 14.25h7",
    stroke: "#9B9AC8",
    strokeWidth: 1.5,
    "data-no-fill": "true"
  })));
};
export { SvgAv5NextStepsGraph as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjEgMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cmVjdCB4PSIwLjc1IiB5PSIxMS4yNSIgd2lkdGg9IjYiIGhlaWdodD0iNiIgcng9IjEiIGZpbGw9IndoaXRlIiBzdHJva2U9IiM5QjlBQzgiIHN0cm9rZS13aWR0aD0iMS41IiBkYXRhLW5vLWZpbGw9InRydWUiLz4KICAgIDxyZWN0IHg9IjE0LjI1IiB5PSIxMS4yNSIgd2lkdGg9IjYiIGhlaWdodD0iNiIgcng9IjEiIGZpbGw9IndoaXRlIiBzdHJva2U9IiM5QjlBQzgiIHN0cm9rZS13aWR0aD0iMS41IiBkYXRhLW5vLWZpbGw9InRydWUiLz4KICAgIDxyZWN0IHg9IjcuNSIgeT0iMC43NSIgd2lkdGg9IjYiIGhlaWdodD0iNiIgcng9IjEiIGZpbGw9IndoaXRlIiBzdHJva2U9IiM5QjlBQzgiIHN0cm9rZS13aWR0aD0iMS41IiBkYXRhLW5vLWZpbGw9InRydWUiLz4KICAgIDxwYXRoIGQ9Ik0xMC41IDdWMTQiIHN0cm9rZT0iIzlCOUFDOCIgc3Ryb2tlLXdpZHRoPSIxLjUiIGRhdGEtbm8tZmlsbD0idHJ1ZSIvPgogICAgPHBhdGggZD0iTTcsMTQuMjUgTDE0LDE0LjI1IiBzdHJva2U9IiM5QjlBQzgiIHN0cm9rZS13aWR0aD0iMS41IiBkYXRhLW5vLWZpbGw9InRydWUiLz4KPC9zdmc+Cg==";